<style lang="sass">
.list-item
  background-color: white
  cursor: pointer

  &:hover
    background-color: #f4f4f4
</style>

<template lang="pug">
div
  v-row(justify='center')
    v-col(sm=8 md=4)
      v-text-field(v-model='keyword' label='Buscar' outlined append-icon='mdi-magnify' @keyup.enter="search(keyword)")
  div.text-center(v-if='!loading && items.length === 0')
    h3 {{message}}
  div.text-center.my-4(v-if='loading')
    v-progress-circular(indeterminate)
  div.list-item(@click='redirect(item.id)' v-for='(item, i) in items' :key='i')
    div.pa-4 {{ item[listBy] }}
    v-divider(v-if='i < items.length - 1')
</template>

<script>
import utils from '../utils/requests'

export default {
  props: {
    url: String,
    title: String,
    attribute: String,
    listBy: String
  },
  data () {
    return {
      items: [],
      loading: false,
      keyword: '',
      message: 'Para visualizar dados, busque por algo.'
    }
  },
  methods: {
    search (keyword) {
      this.loading = true
      utils.postAPI(this.url, { 'string': keyword }).then(res => {
        this.items = res[this.attribute] // ?
        console.log(this.items)
        if (this.items.length === 0) {
          this.message = 'Nenhum resultado encontrado para sua busca.'
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    redirect (id) {
      if (this.attribute === 'events') {
        this.$router.push(`/event/${id}`)
      } else if (this.attribute === 'users') {
        this.$router.push(`/user/${id}`)
      } else if (this.attribute === 'people') {
        this.$router.push(`/person/${id}`)
      }
    }
  }
}
</script>
